/* eslint-disable multiline-ternary */
/* eslint-disable max-len */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import {
  Container, Row, Col,
} from '../../base/Grid';
import Typography from '../../base/Typography';

import AccoladesData from './accoladesData';
import {
  AccoladesSection, HeadingCol, AccoladeContainer, AccoladeContainerBlockquote, AccoladeTitleTypography,
} from './styles';

export const AccoladesComponent = ({
  id, containerStyles, heading, headingProps, accolades, accoladeTitleProps, accoladeDescriptionProps,
}) => {
  useEffect(() => {
    // validate all accolades passed in are correct
    if (accolades.length === 0) {
      console.error('Missing accolades. At least one accolade is required.');
    }
    for (let i = 0; i < accolades.length; i += 1) {
      if (accolades[i].accolade in AccoladesData) {
        // check if accolade requires sup
        if (AccoladesData[accolades[i].accolade]().blockquote && !accolades[i].sup) {
          console.error(`${accolades[i]} accolade requires a sup to be passed in for footer reference.`);
        }
      } else {
        // invalid accolade provided
        console.error('Provided accolade identifier is invalid. Possible accodates are [financialStrengthRating, rankedInvestmentService, yearsOfService, dividend, rankedInsuranceCompany, policyholderRetention, moodysInvestorsService, AMBestCompany, fitchRatings, SPGlobalRatings].');
      }
    }
  }, []);

  const mediumBreakpoint = 12 / accolades.length;
  const smallBreakpoint = accolades.length === 4 ? 6 : 12;
  return (
    <AccoladesSection id={`section-${id}`} containerStyles={containerStyles}>
      <Container>
        { heading && ( // only show heading if provided
          <Row>
            <HeadingCol xsmall={12}>
              <Typography disableBottomPadding {...headingProps}>{heading}</Typography>
            </HeadingCol>
          </Row>
        )}
        <Row align="center">
          { accolades.map((accolade) => {
            // grab data for accolade
            const data = AccoladesData[accolade.accolade](accolade.sup);
            // grab the container, depends on blockquote
            const StyledAccoladeContainer = data.blockquote ? AccoladeContainerBlockquote : AccoladeContainer;
            return (
              <Col key={accolade.accolade} xsmall={12} small={smallBreakpoint} medium={mediumBreakpoint}>
                <StyledAccoladeContainer>
                  <Typography component="h4" align="center" disableBottomPadding>
                    <AccoladeTitleTypography {...accoladeTitleProps}>{data.title}</AccoladeTitleTypography>
                    <span className="nmx-assistive-text">{data.assistiveTitle}</span>
                  </Typography>
                  <Typography {...accoladeDescriptionProps} disableBottomPadding>{data.description}</Typography>
                  {data.footer && (
                    <footer className="nmx-hide">{data.footer}</footer>
                  )}
                </StyledAccoladeContainer>
              </Col>
            );
          })}
        </Row>
      </Container>
    </AccoladesSection>
  );
};

AccoladesComponent.propTypes = {
  id: PropTypes.string.isRequired,
  /** styled component css`...` for the container section - used to change background colors, or other conatiner styles */
  containerStyles: PropTypes.any,
  /** Optional heading for the accolades section, if not provided, will not show any heading */
  heading: PropTypes.string,
  /** Override default typography props for the heading */
  headingProps: PropTypes.object,
  /** Array of accoladed to display in the section */
  accolades: PropTypes.arrayOf(PropTypes.shape({
    /** The 'id' of the accolade wanting to display */
    accolade: PropTypes.oneOf(['financialStrengthRating', 'rankedInvestmentService', 'yearsOfService', 'dividend', 'rankedInsuranceCompany', 'policyholderRetention', 'moodysInvestorsService', 'AMBestCompany', 'fitchRatings', 'SPGlobalRatings']).isRequired,
    /** The sup number corresponding with the footer reference, Required for accolades needing source to cite */
    sup: PropTypes.number,
  })).isRequired,
  /** Override default typography props for the accolade titles */
  accoladeTitleProps: PropTypes.object,
  /** Override default typography props for the accolade descriptions */
  accoladeDescriptionProps: PropTypes.object,
};

AccoladesComponent.defaultProps = {
  containerStyles: '',
  headingProps: { component: 'h2', align: 'center', weight: 400 },
  accoladeTitleProps: { component: 'span', variant: 'jumbo-type', weight: 200 },
  accoladeDescriptionProps: { component: 'p', align: 'center' },
};

export default AccoladesComponent;
